'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import CustomWidgetTags from 'ContentUtils/constants/CustomWidgetTags';
import TagsAndCategorySelect from 'DesignEditorsUI/components/shared/controls/customWidgets/TagsAndCategorySelect';
import CategoriesSelect from 'DesignEditorsUI/components/customWidgetEditor/sidebar/main/CategoriesSelect';

const i18nkey = key => `DesignEditorsUI.customWidgetEditor.sidebar.main.filterTags.${key}`;

class FilterTags extends Component {
  constructor(...args) {
    super(...args);

    this.handleCustomTagsChange = tags => {
      const customTags = tags.map(tag => ({
        name: tag,
        source: 'USER'
      }));
      this.props.onTagsChange([...this.nonCustomTags, ...customTags], tags.map(
      /* need to persist value instead of keys */
      tag => CustomWidgetTags[tag]));
    };
  }

  get nonCustomTags() {
    const {
      customWidgetTags
    } = this.props;
    return customWidgetTags.filter(({
      source
    }) => source !== 'USER');
  }

  get customTags() {
    const {
      customWidgetTags
    } = this.props;
    return customWidgetTags.filter(({
      source
    }) => source === 'USER');
  }

  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.props.isModuleCategoriesUngated && /*#__PURE__*/_jsx(ToolFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nkey('categories.label')
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nkey('categories.tooltip')
        }),
        children: /*#__PURE__*/_jsx(CategoriesSelect, {
          isReadOnly: this.props.isReadOnly,
          selectedCategories: this.props.customWidgetCategories,
          onChange: this.props.onCategoriesChange
        })
      }), /*#__PURE__*/_jsx(ToolFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nkey('tags.label')
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nkey('tags.tooltip')
        }),
        children: /*#__PURE__*/_jsx(TagsAndCategorySelect, {
          isReadOnly: this.props.isReadOnly,
          selectedTags: this.customTags.map(({
            name
          }) => name),
          onChange: this.handleCustomTagsChange,
          showCategories: false
        })
      })]
    });
  }

}

export default FilterTags;